import React, { useEffect, useMemo, useState } from 'react';

import { Context, Request, create } from './util';
import LogIn from './LogIn';
import Main from './Main';

const recreate = {
  path: () => {
    const previousPath = localStorage.getItem('path');
    if (previousPath) {
      if (previousPath.startsWith('/schedules')) {
        return '/schedules';
      } else {
        return previousPath;
      }
    } else {
      return '/schedules';
    }
  },
}

function App() {
  const [token, setToken] = useState({
    access: localStorage.getItem('accessToken') || '',
    refresh: localStorage.getItem('refreshToken') || '',
  });

  const [newAttender    , setNewAttender    ] = useState(create.attender());
  const [newSchedule    , setNewSchedule    ] = useState(create.schedule());
  const [path           , setPath           ] = useState(recreate.path());
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [ticketDetail   , setTicketDetail   ] = useState([]);
  const [ticketer       , setTicketer       ] = useState(parseInt(localStorage.getItem('ticketer') || '-1'));
  const [ticketers      , setTicketers      ] = useState([]);
  const [ticketOptions  , setTicketOptions  ] = useState([]);
  const [tickets        , setTickets        ] = useState([]);

  const request = useMemo(() => new Request(token, setToken), [
    token,
    setToken,
  ]);

  const context = new Context(() => {
    return {
      newAttender    , setNewAttender,
      newSchedule    , setNewSchedule,
      path           , setPath,
      request,
      snackbarMessage, setSnackbarMessage,
      ticketDetail   , setTicketDetail,
      ticketer       , setTicketer,
      ticketers      , setTicketers,
      ticketOptions  , setTicketOptions,
      tickets        , setTickets,
      token          , setToken,
    };
  });

  useEffect(() => {
    if (token.access === '') {  // logged out
      localStorage.setItem('accessToken', '');
      localStorage.setItem('attender', -1);
      localStorage.setItem('path', recreate.path());
      localStorage.setItem('refreshToken', '');
      localStorage.setItem('ticketer', -1);
    } else {
      localStorage.setItem('accessToken', token.access);
      localStorage.setItem('refreshToken', token.refresh);
    }
  }, [token]);

  useEffect(() => {
    localStorage.setItem('path', path);
  }, [path]);

  useEffect(() => {
    localStorage.setItem('ticketer', ticketer);
  }, [ticketer]);

  useEffect(() => {
    let newTicketDetail = {};
    for (const ticket of tickets) {
      newTicketDetail[ticket.rowid] = ticket;
    }
    setTicketDetail(newTicketDetail);

    let ticketOptions = [];
    for (const ticket of tickets) {
      if (ticket.issuable) {
        ticketOptions.push({'label': ticket.name, 'value': ticket.rowid});
      }
    }
    setTicketOptions(ticketOptions);
  }, [tickets]);

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', (event) => {
      const pathFrom = localStorage.getItem('path');
      window.history.pushState(null, document.title, window.location.href);
      if (pathFrom.startsWith('/attenders/attender')) {
        setPath('/attenders');
      } else if (pathFrom.startsWith('/schedules/attender')) {
        setPath('/schedules');
      }
    });
  }, []);

  return (<>
    <LogIn context={context} />
    {token.access !== '' && <Main context={context} />}
  </>);
}

export default App;
